var _ellipse, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAvatarBg = function SvgIconAvatarBg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 53.652,
    viewBox: "0 0 53.652 53.652",
    width: 53.652,
    ref: svgRef
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "themed-fill muted",
    cx: 26.826,
    cy: 26.826,
    fill: "#1d5a71",
    rx: 26.826,
    ry: 26.826
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.131,
    cy: 18.554,
    r: 8.199
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.221 10c-9.472 0-17.221 3.689-17.221 8.2v4.1h34.441v-4.1c0-4.511-7.749-8.2-17.22-8.2z",
    transform: "translate(9.897 20.037)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAvatarBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-avatar-bg.e71c10df.svg";
export { ForwardRef as ReactComponent };